import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

interface Props {
  planId?: number;
}

export const usePlan = ({ planId }: Props) => {
  const { data, loading, error } = useQuery<
    GetPlanForUsePlanQuery,
    GetPlanForUsePlanQueryVariables
  >(GET_PLAN_QUERY, {
    skip: !planId,
    variables: { planId: planId || -1 },
  });

  return { data: data?.plan, error, loading };
};

export const GET_PLAN_QUERY = gql`
  query GetPlanForUsePlan($planId: Int!) {
    plan(id: $planId) {
      id
      utilityAccounts {
        id
        utility {
          id
          displayName
          state {
            name
            abbreviation
          }
        }
      }
      paymentMethod {
        id
      }
    }
  }
`;

export const getPlanMock: GetPlanForUsePlanQuery = {
  plan: {
    id: 1,
    paymentMethod: {
      id: 1000,
    },
    utilityAccounts: [
      {
        id: 100,
        utility: {
          displayName: 'Pepco',
          id: 2,
          state: {
            name: 'Maryland',
            abbreviation: 'MD',
          },
        },
      },
    ],
  },
};

export const usePlanMock = {
  data: getPlanMock.plan,
  error: undefined,
  loading: false,
};
